/**
 *  运款付款单
 * @author FJJ
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2022/09/14      1.0    First version   使用统一的组件
 *
 * @copyright 2021-2022, all rights reserved. Essa.cn
 * */

import React,{Fragment} from 'react';
import { Button, Spin,Row,Col,message,Empty} from 'antd';
import Lang from "@components/Lang/Lang";
import PropTypes from "prop-types";
import {toFixed2,isEmpty} from '@utils/utils';
import DownloadBtnModal from "./common/DownloadBtnModal";
import HistoryBtnModal from './common/HistoryBtnModal';
import ConfirmAlert from './common/ConfirmAlert';
import TableFreightRemittanceRu from './common/TableFreightRemittanceRu';
import TableFreightRemittanceEn from './common/TableFreightRemittanceEn';
import ShipperManagementAction from "../../ShipperManagement.action";
import HistoryTop from "./common/HistoryTop";
import FormFormat from '@components/FormFormat/FormFormat';
import PageCommon from  "@components/PageCommon/PageCommon";

export default class FreightRemittanceEdit extends React.Component{
    static propTypes = {
        orderType: PropTypes.string.isRequired,
    }
    static defaultProps = {
        orderType:'',
    }
    constructor(props) {
        super(props);
        this.state = {
            list:[],
            orderInfo: {},
            loading:false,
            //历史记录面板
            isShowHistoryPanel:false,
            isShowHistoryId:null,
            // 编辑
            editRuOption:[
                {
                    cnTitle:'柜号',
                    cnTitleId:'GuiHao',
                    name:'cabinetNumRu',
                    cnPlaceholder:'EX:85/003',
                    cnPlaceholderId:'YunFeiHuiKuanDanGuiHaoLiZi',
                    required:true
                },
                {
                    cnTitle:'合同号和日期',
                    cnTitleId:'HeTongHaoHeRiQi',
                    name:'contractCodeRu',
                    cnPlaceholder:'EX:ESSA-TR 003 от «26» мая 2022 г.',
                    cnPlaceholderId:'YunFeiHuiKuanDanHeTongHaoHeRiQiLiZiRu',
                    required:true
                },
                {
                    cnTitle:'日期',
                    cnTitleId:'RiQi',
                    // type:'Date',
                    name:'dateRu', // 日期
                    cnPlaceholder:'EX:«02» Августа 2022 г.',
                    cnPlaceholderId:'YunFeiHuiKuanDanRiQiLiZiRu',
                    required:true
                },
                {
                    cnTitle:'描述',
                    cnTitleId:'MiaoShu',
                    type:'TextArea',
                    name:'descRu',  // 描述
                    cnPlaceholder:'EX:Доставка товара по маршруту' +
                        '1.в т/п ПП Забайкальск: Гуанчжоу – т/п ПП Забайкальск (2652.2 км)' +
                        '2. по ЕАЭС: т/п ПП Забайкальск – Белый Раст (5125.7 км), контейнер № OOLU8357922, инвойс № RU20220012 от 22.06.2022 на сумму 10,000.00 USD',
                    cnPlaceholderId:'YunFeiHuiKuanDanMiaoShuLiZiRu',
                    required:true
                },
                {
                    cnTitle:'总运费',
                    cnTitleId:'ZongYunFei',
                    // type:'Number',
                    name:'totalPriceRu',
                    cnPlaceholder:'EX:10,000',
                    cnPlaceholderId:'YunFeiHuiKuanDanZongYunFei',
                    required:true
                },
            ],
            editEnOption:[
                {
                    cnTitle:'柜号',
                    cnTitleId:'GuiHao',
                    name:'cabinetNumEn',
                    cnPlaceholder:'EX:85/003',
                    cnPlaceholderId:'YunFeiHuiKuanDanGuiHaoLiZi',
                    required:true
                },
                {
                    cnTitle:'合同号和日期',
                    cnTitleId:'HeTongHaoHeRiQi',
                    name:'contractCodeEn',
                    cnPlaceholder:'EX:ESSA-TR 003 dated May 26, 2022',
                    cnPlaceholderId:'YunFeiHuiKuanDanHeTongHaoHeRiQiLiZiEn',
                    required:true
                },
                {
                    cnTitle:'日期',
                    cnTitleId:'RiQi',
                    // type:'Date',
                    name:'dateEn', // 日期
                    cnPlaceholder:'EX:«02» August 2022',
                    cnPlaceholderId:'YunFeiHuiKuanDanRiQiLiZiRu',
                    required:true
                },
                {
                    cnTitle:'描述',
                    cnTitleId:'MiaoShu',
                    type:'TextArea',
                    name:'descEn',  // 描述
                    cnPlaceholder:'EX:Delivery of goods along the route' +
                        '1.to the P/P Zabaikalsk: Guangzhou – P/P Zabaikalsk (2652.2 km);' +
                        '2. on the EAEU: P/P Zabaikalsk – Beliy Rast (5125.7 km), container no. OOLU8357922, invoice no. RU20220012 dated 22.06.2022 in the amount of 10,000.00 USD',
                    cnPlaceholderId:'YunFeiHuiKuanDanMiaoShuLiZiEn',
                    required:true
                },
                {
                    cnTitle:'总运费',
                    cnTitleId:'ZongYunFei',
                    // type:'Number',
                    name:'totalPriceEn',
                    cnPlaceholder:'EX:10,000',
                    cnPlaceholderId:'YunFeiHuiKuanDanZongYunFei',
                    required:true
                },
            ],
            canEdit:false,
        }
    }
    getData(){
        this.fetch(this.props.containerId)
    }
    /**
     * 展示历史记录面板，查询当前历史版本ID
     * @param item
     */
    showHistoryPanel(item){
        this.setState({
            isShowHistoryPanel:true,
            orderInfo: {},
        },()=>this.fetch('',item.id))

    }

    /**
     * 隐藏历史记录面板,查询当前集柜ID
     **/
    hideHistoryPanel(){
        this.setState({
            isShowHistoryPanel:false,
            orderInfo: {},
        },()=>this.fetch(this.props.containerId))
    }
    /**
     * 加载状态
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /**
     * 设置 信息头
     * */
    handleRes(res,isShowHistoryId){
        this.loading(false)
        const {success,valid} = res;
        if(success&&valid){
            this.setState({
                orderInfo:res.model||{},
                isShowHistoryId:isShowHistoryId,
            })
        }else{
            if(res.message){
                message.warning(res.message);
            } else message.warning(Lang({id:'CaoZuoShiBai',default: "操作失败",}));
        }
    }
    onRefTabOne = (ref) =>  this.onRefTabChildOne = ref;
    /**
     * 进入请求
     * */
    fetch(sContainerId,sId){
        let postData = {}
        if(!isEmpty(sContainerId)){
            postData = {
                containerId: sContainerId,
            }
        }
        if(!isEmpty(sId)){
            postData = {
                id: sId,
            }
        }
        this.loading(true)
        ShipperManagementAction.autoFetchAction(postData,'/service/mg/con/report/freight-pay-order/details').then(res=>this.handleRes(res.data,sId)).catch(err=>this.handleRes(err))
    }
    /**
     * 编辑
     * */
    edit(flag=true){
        this.setState({
            canEdit: flag
        })
        this.props.handleEdit(flag)
    }
    async save(){
        const res = await this.onRefFormFormat.handleOK();
        const res2 = await  this.onRefFormFormatTwo.handleOK();
        if(res.success&&res2.success){
            this.loading(true)
            let postData = {...res.data,...res2.data}
            const { orderInfo } = this.state;
            postData['containerId'] = this.props.containerId;
            postData['version'] = orderInfo.version;
            // postData['letterContent'] = postData.letterContent?postData.letterContent.replace(new RegExp('\n','g'),'<br/>'):''
            ShipperManagementAction.autoFetchAction(postData,'/service/mg/con/report/freight-pay-order/save').then(res=>this.handleSaveRes(res.data)).catch(err=>this.handleSaveRes(err))
        }
    }
    handleSaveRes(res){
        this.loading(false)
        const {success,valid} = res;
        if(success&&valid){
            message.success(Lang({id:'CaoZuoChengGong',default: "操作成功",}));
            this.fetch(this.props.containerId)
            this.edit(false)
        }else{
            if(res.message){
                message.warning(res.message);
            } else message.warning(Lang({id:'CaoZuoShiBai',default: "操作失败",}));
        }
    }
    onRefForm = (ref) =>  this.onRefFormFormat = ref;
    onRefFormTwo = (ref) => this.onRefFormFormatTwo = ref;
    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref; 
    componentDidMount() {
        this.fetch(this.props.containerId)
        if(this.props.onRef)this.props.onRef(this);
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render(){
        const { orderInfo,loading, isShowHistoryPanel,canEdit,editRuOption,editEnOption } = this.state;
        const {orderType,containerId,downloadUrlPdf,downloadUrlExcel} = this.props;
        const pageTitle = Lang({id: 'YunFeiHuiKuanDan', default: '运费汇款单'})
        let btnList = []

        if(!isShowHistoryPanel && !canEdit){
            btnList= [
                { 
                    btn: <span>{Lang({id: "BianJi",default: "编辑"})}</span>,
                    icon:"ri-quill-pen-line color-blue mr_4",
                    btnClick:()=>this.edit()
                },
                { 
                    btn: <DownloadBtnModal title={<div>
                        <i className='ri-download-2-line color-blue mr_4'></i>
                        {Lang({id: "XiaZaiExcel",default: "下载Excel"})}
                    </div> }
                    downloadUrl={downloadUrlExcel}
                    orderInfo={orderInfo} />,
                    btnClick:()=>{}
                },{ 
                    btn: <DownloadBtnModal title={<div>
                        <i className='ri-download-2-line color-danger mr_4'></i>
                        {Lang({id: "XiaZaiGaiZhangPDF",default: "下载盖章PDF"})}
                    </div>}
                    downloadUrl={downloadUrlPdf}
                    orderInfo={orderInfo} type={'pdf'} />,
                    btnClick:()=>{}
                },{ 
                    btn: <HistoryBtnModal className={"margin-left-5"}
                    title={Lang({id: 'LiShiJiLu', default: '历史记录'})}
                    orderType={orderType}
                    recoveryHistoryBack={this.getData.bind(this)}
                    showHistoryPanel={item=>this.showHistoryPanel(item)}
                    containerId={containerId} />,
                    btnClick:()=>{}
                }
            ]
    
            if(orderInfo.status === '10' || orderInfo.status === '20'){
                btnList.push({
                    btn: <ConfirmAlert orderInfo={orderInfo} orderType={orderType} callBack={()=>this.getData()} />,
                    btnClick:()=>{}
                })
            }
        }


        return (<PageCommon onRef={this.onRefPageCommon} className={"transferWrap"} btnList={btnList}> <Spin spinning={loading}>
            <div className={"packListWrap"}>
                {orderInfo.id&&!isShowHistoryPanel&&!canEdit&&<div>

                    {/*操作区*/}
                    {/* <div className={"flex-item fixed-footer__wrap"}>
                        <Button onClick={()=>this.edit()}>{Lang({id: "BianJi",default: "编辑"})}</Button>
                        <DownloadBtnModal title={Lang({id: "XiaZaiExcel",default: "下载Excel"})}
                                          className={"margin-left-5"}
                                          downloadUrl={downloadUrlExcel}
                                          orderInfo={orderInfo} />
                        <DownloadBtnModal title={Lang({id: "XiaZaiGaiZhangPDF",default: "下载盖章PDF"})}
                                          className={"margin-left-5"}
                                          type={'pdf'}
                                          downloadUrl={downloadUrlPdf}
                                          orderInfo={orderInfo} />
                        <HistoryBtnModal className={"margin-left-5"}
                                         title={
                                             pageTitle  + Lang({id: 'LiShiJiLu', default: '历史记录'})
                                         }
                                         orderType={orderType}
                                         showRecover={true}
                                         recoverUrl={"/service/mg/con/report/freight-pay-order/recovery-version"}
                                         recoveryHistoryBack={(res)=>this.fetch(containerId)}
                                         showHistoryPanel={item=>this.showHistoryPanel(item)}
                                         containerId={containerId} />
                        <ConfirmAlert orderInfo={orderInfo} orderType={orderType} callBack={()=>this.getData()} />
                    </div> */}
                </div>}
                {isShowHistoryPanel&&<HistoryTop title={pageTitle}
                                                 showRecover={true}
                                                 recoverUrl={"/service/mg/con/report/freight-pay-order/recovery-version"}
                                                 recoveryHistoryBack={(res)=>this.hideHistoryPanel(res)}
                                                 callBack={()=>this.hideHistoryPanel()}
                                                 orderInfo={orderInfo} />}
                {/* 汇款内容 start */}
                {orderInfo.id?<Row className={"borderTopWrap"}>
                    <Col span={12} className={"font-18"}>
                        {canEdit&&<div>
                            <p>{Lang({id: "EWen",default: "俄文"})}</p>
                            <FormFormat onRef={this.onRefForm}
                                        options={editRuOption}
                                        formLayout = "vertical"
                                        className={'form-format-white'}
                                        initialValues={orderInfo} />
                        </div>}
                        {/* todo 行编影响 表格数据*/}
                        <TableFreightRemittanceRu orderInfo={orderInfo} />
                    </Col>
                    <Col span={11} className={"font-18"} offset={1}>
                        {canEdit&&<div>
                            <p>{Lang({id: "YingWen",default: "英文"})}</p>
                            <FormFormat onRef={this.onRefFormTwo}
                                        options={editEnOption}
                                        formLayout = "vertical"
                                        className={'form-format-white'}
                                        initialValues={orderInfo} />
                        </div>}
                        {/* todo 行编影响 表格数据*/}
                        <TableFreightRemittanceEn orderInfo={orderInfo} />
                    </Col>
                </Row>:<div className={"bar"}>
                    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                </div>}
                {/* 汇款内容 end */}
                {canEdit&&<div className={"text-center"}>
                    <Button type="primary" onClick={()=>this.save()}>{Lang({id: "QueDing",default: "确定"})}</Button>
                    <Button className={"margin-left-5"} onClick={()=>this.edit(false)}>{Lang({id: "QuXiao",default: "取消"})}</Button>
                </div>}
                {/* 公共内容 END */}

            </div>
        </Spin> </PageCommon>)
    }
}
